import { render } from "./editorscard.vue?vue&type=template&id=068cf012"
import script from "./editorscard.vue?vue&type=script&lang=js"
export * from "./editorscard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__